// Web Locks, bounded. navigator.locks.query() has been seen never to settle
// (headless Chrome), and a launch must not wait on it (d75774d).

/** Names of Web Locks held or pending right now, or null when unknown within `ms`. */
export async function heldLocks(locks = globalThis.navigator?.locks, ms = 500) {
  try {
    const q = await Promise.race([
      locks?.query?.() ?? Promise.resolve(null),
      new Promise((r) => setTimeout(() => r(null), ms)),
    ]);
    return q ? [...(q.held || []), ...(q.pending || [])].map((l) => l.name) : null;
  } catch {
    return null;
  }
}
